import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  const highlights = [
    {
      icon: "🎯",
      title: "Exam-Focused Strategy",
      text: "A structured system designed to help aspirants prepare with clarity, consistency, and exam relevance."
    },
    {
      icon: "📚",
      title: "Complete Coverage",
      text: "Support for Prelims, Mains, and Interview through organized study modules and revision-first planning."
    },
    {
      icon: "📈",
      title: "Performance Tracking",
      text: "Track learning progress, identify weak areas, and build improvement through measurable preparation."
    }
  ];

  const pillars = [
    "Structured Preparation Strategy",
    "Comprehensive Prelims & Mains Test Series",
    "Performance Analytics & Ranking",
    "Continuous Progress Tracking",
    "Revision-First Study Framework",
    "UPSC-Oriented Smart Learning"
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(34,197,94,0.08), transparent 24%), radial-gradient(circle at top right, rgba(56,189,248,0.08), transparent 26%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        color: "#fff"
      }}
    >
      {/* HERO */}
      <section className="container py-5 py-lg-6">
        <div className="text-center mb-5">
          <div
            style={{
              display: "inline-block",
              padding: "8px 16px",
              borderRadius: "999px",
              background: "rgba(56,189,248,0.12)",
              border: "1px solid rgba(56,189,248,0.20)",
              color: "#7dd3fc",
              fontWeight: 700,
              fontSize: "13px",
              letterSpacing: "1px"
            }}
          >
            ABOUT UPSC TITAN SCORE
          </div>

          <h1
            className="fw-bold mt-4"
            style={{
              fontSize: "clamp(2rem, 5vw, 3.4rem)",
              lineHeight: "1.15",
              background: "linear-gradient(90deg, #ffffff, #cbd5e1, #38bdf8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            A Serious Learning Platform
            <br />
            For Serious UPSC Aspirants
          </h1>

          <p
            className="mx-auto mt-4"
            style={{
              maxWidth: "900px",
              color: "#cbd5e1",
              fontSize: "1.05rem",
              lineHeight: "1.9"
            }}
          >
            UPSC Titan Score is built to help Civil Services aspirants prepare
            with structure, discipline, and exam-oriented clarity. Our platform
            supports focused preparation for <strong>Prelims</strong>,{" "}
            <strong>Mains</strong>, and <strong>Interview</strong> through
            guided study systems, smart practice, and progress-based learning.
          </p>
        </div>

        {/* TRUST STATS */}
        <div className="row g-4 mb-5">
          <div className="col-12 col-md-4">
            <div style={statCardStyle}>
              <h2 style={statNumberStyle}>Prelims</h2>
              <p style={statTextStyle}>Topic-wise learning and practice</p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div style={statCardStyle}>
              <h2 style={statNumberStyle}>Mains</h2>
              <p style={statTextStyle}>Answer writing and structured thinking</p>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div style={statCardStyle}>
              <h2 style={statNumberStyle}>Interview</h2>
              <p style={statTextStyle}>Confidence, personality, and analysis</p>
            </div>
          </div>
        </div>

        {/* MISSION + WHY */}
        <div className="row g-4 align-items-stretch mb-5">
          <div className="col-lg-7">
            <div style={glassCardStyle}>
              <h3 className="fw-bold mb-3" style={{ color: "#f8fafc" }}>
                Our Mission
              </h3>
              <p style={bodyTextStyle}>
                Our mission is to simplify the UPSC preparation journey by
                creating a system that reduces confusion and improves direction.
                Instead of random study, we focus on a disciplined learning path
                built around consistency, concept clarity, revision planning,
                and exam-oriented execution.
              </p>
              <p style={bodyTextStyle}>
                UPSC Titan Score is designed for aspirants who want more than
                just scattered materials. It is for students who want a
                preparation environment that feels structured, reliable, and
                result-driven.
              </p>

              <div className="row mt-4">
                {pillars.map((item, index) => (
                  <div className="col-12 col-md-6 mb-3" key={index}>
                    <div style={featurePillStyle}>✔ {item}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div style={premiumPanelStyle}>
              <div style={miniBadgeStyle}>WHY ASPIRANTS CHOOSE US</div>
              <h4 className="fw-bold mt-3 mb-3" style={{ color: "#ffffff" }}>
                Preparation Should Feel Organized, Not Overwhelming
              </h4>
              <p style={bodyTextStyle}>
                UPSC preparation often fails not because students lack effort,
                but because they lack a reliable system. Our goal is to create a
                premium learning experience where aspirants feel clarity,
                direction, and momentum every week.
              </p>

              <div className="mt-4">
                <div style={timelineItemStyle}>📘 Structured learning flow</div>
                <div style={timelineItemStyle}>🧠 Smart exam preparation</div>
                <div style={timelineItemStyle}>📊 Progress-driven dashboard</div>
                <div style={timelineItemStyle}>🎯 Focus on real UPSC needs</div>
              </div>
            </div>
          </div>
        </div>

        {/* 3 CARDS */}
        <div className="row g-4 mb-5">
          {highlights.map((item, index) => (
            <div className="col-12 col-md-4" key={index}>
              <div style={modernCardStyle}>
                <div style={iconWrapStyle}>{item.icon}</div>
                <h5 className="fw-bold mb-3" style={{ color: "#f8fafc" }}>
                  {item.title}
                </h5>
                <p style={bodyTextStyle}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={ctaStyle} className="text-center">
          <div style={miniBadgeStyle}>PREMIUM UPSC LEARNING</div>
          <h3 className="fw-bold mt-3 mb-3" style={{ color: "#fff" }}>
            Build a Preparation System You Can Actually Follow
          </h3>
          <p
            className="mx-auto"
            style={{
              maxWidth: "820px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              fontSize: "1rem"
            }}
          >
            UPSC Titan Score is built to help aspirants stay focused, improve
            steadily, and prepare with confidence through a premium structured
            learning experience.
          </p>

          <div className="mt-4 d-flex flex-wrap justify-content-center gap-3">
            <Link to="/subscription" className="btn btn-success btn-lg px-4">
              Start Premium
            </Link>
            <Link to="/" className="btn btn-outline-light btn-lg px-4">
              Explore Platform
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ================= STYLES ================= */
const glassCardStyle = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "28px",
  padding: "28px",
  backdropFilter: "blur(16px)",
  boxShadow: "0 18px 40px rgba(0,0,0,0.25)",
  height: "100%"
};

const premiumPanelStyle = {
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.95), rgba(17,24,39,0.88))",
  border: "1px solid rgba(56,189,248,0.16)",
  borderRadius: "28px",
  padding: "28px",
  height: "100%",
  boxShadow: "0 18px 40px rgba(0,0,0,0.25)"
};

const modernCardStyle = {
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.92), rgba(17,24,39,0.88))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "26px",
  padding: "26px",
  boxShadow: "0 14px 34px rgba(0,0,0,0.24)",
  height: "100%"
};

const statCardStyle = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "24px",
  padding: "26px",
  textAlign: "center",
  backdropFilter: "blur(16px)",
  boxShadow: "0 12px 30px rgba(0,0,0,0.18)"
};

const statNumberStyle = {
  color: "#38bdf8",
  fontWeight: 900,
  marginBottom: "8px"
};

const statTextStyle = {
  color: "#cbd5e1",
  marginBottom: 0,
  fontSize: "0.98rem"
};

const bodyTextStyle = {
  color: "#94a3b8",
  lineHeight: "1.9",
  fontSize: "0.98rem",
  marginBottom: "12px"
};

const featurePillStyle = {
  background: "rgba(34,197,94,0.10)",
  border: "1px solid rgba(34,197,94,0.18)",
  borderRadius: "16px",
  padding: "12px 14px",
  color: "#bbf7d0",
  fontWeight: 600,
  fontSize: "0.94rem"
};

const miniBadgeStyle = {
  display: "inline-block",
  padding: "8px 14px",
  borderRadius: "999px",
  background: "rgba(56,189,248,0.10)",
  border: "1px solid rgba(56,189,248,0.16)",
  color: "#7dd3fc",
  fontWeight: 700,
  fontSize: "12px",
  letterSpacing: "1px"
};

const timelineItemStyle = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.06)",
  borderRadius: "16px",
  padding: "12px 14px",
  color: "#e2e8f0",
  marginBottom: "12px",
  fontWeight: 600
};

const iconWrapStyle = {
  width: "58px",
  height: "58px",
  borderRadius: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.5rem",
  background: "rgba(56,189,248,0.12)",
  border: "1px solid rgba(56,189,248,0.18)",
  marginBottom: "18px"
};

const ctaStyle = {
  background:
    "linear-gradient(145deg, rgba(2,6,23,0.96), rgba(15,23,42,0.92))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "30px",
  padding: "42px 24px",
  boxShadow: "0 18px 40px rgba(0,0,0,0.28)"
};